import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Avatar,
  Typography,
  Chip,
  Divider,
  Stack,
  Grid,
} from '@mui/material';
import {
  LocalHospital,
  Business,
  AccessTime,
  CalendarToday,
  Language,
  School,
} from '@mui/icons-material';
import { Doctor } from '../types';

interface DoctorProfileCardProps {
  doctor: Doctor;
}

export const DoctorProfileCard: React.FC<DoctorProfileCardProps> = ({ doctor }) => {
  return (
    <Card sx={{ height: '100%', borderRadius: 2, boxShadow: 2 ,position:"relative"}}>
       <Box sx={{height:70,background:"#AA5B17"}}>

        </Box>
      <CardContent sx={{ p: 3 }}>
       
        {/* Profile Header */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', mb: 3 }}>
          <Avatar
            src={doctor?.personalInfo.photo}
            alt={doctor?.personalInfo.name}
            sx={{ width: 100, height: 100, mb: 2,position:"absolute",top:20 }}
          />
          <Typography variant="h5" fontWeight="bold" textAlign="left" sx={{marginTop:4}}>
            {doctor?.personalInfo.name}
          </Typography>
          <Typography variant="body2" sx={{color:"#E6B57E"}} textAlign="left" mt={0.5} >
            {doctor?.professionalInfo.specialty}
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="left">
            {doctor?.professionalInfo.subSpecialty}
          </Typography>
          <Chip
            label={`Tier ${doctor.professionalInfo.tier}`}
            color="primary"
            size="small"
            sx={{ mt: 1,width:"50px" }}
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Practice Information */}
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LocalHospital color="primary" fontSize="small" />
            <Typography variant="body2">{doctor.practiceInfo.hospital}</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Business color="primary" fontSize="small" />
            <Typography variant="body2">{doctor.practiceInfo.clinic}</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AccessTime color="primary" fontSize="small" />
            <Typography variant="body2">{doctor.preferences.preferredTime}</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalendarToday color="primary" fontSize="small" />
            <Typography variant="body2">
              {doctor.preferences.preferredDays.join(', ')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Language color="primary" fontSize="small" />
            <Typography variant="body2">
              {doctor.preferences.languages.join(', ')}
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ my: 2 }} />

        {/* Summary Statistics */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={4}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h6" fontWeight="bold" color="#DA9244" >
                25
              </Typography>
              <Typography variant="caption" color="text.secondary">
                CLINIC GAP
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h6" fontWeight="bold" color="#DA9244" >
                {doctor.practiceMetrics.patientVolume}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                PRESCRIPTIONS
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h6" fontWeight="bold" color="#DA9244" >
                1.5M
              </Typography>
              <Typography variant="caption" color="text.secondary">
                PATIENT VISITS
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Follow-ups */}
        <Box>
          <Typography variant="subtitle2" fontWeight="bold" mb={1}>
            FOLLOW-UPS
          </Typography>
          <Stack spacing={1}>
            {doctor.professionalInfo.fellowships.map((fellowship, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1,p:1,borderRadius:"10px" ,backgroundColor:"#FCF3C8"}}>
                <School color="action" fontSize="small" />
                <Typography color="#DA9244" variant="body2">{fellowship}</Typography>
              </Box>
            ))}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};

